import { Injectable } from '@angular/core';
import { AuthenticatedService } from '../_common/authenticated.service';
import { Observable } from 'rxjs';
import { OxygenMeasure } from '../_models/oxygenMeasure';
import { FlowRate } from '../_models/flowRate';

@Injectable()
export class MeasurementsService {
    private api: string = '/api/measurements';

    constructor(
        private authenticatedService: AuthenticatedService
    ) { }


    getLatest(controllerId: string):Observable<OxygenMeasure> {  

        let url = `${this.api}/${controllerId}/last`;
        
        return this.authenticatedService.getObservable(url);
    }

    getFlowRate(controllerId: string):Observable<Array<FlowRate>> {  

        let url = `${this.api}/${controllerId}/flowrate24`;
        
        return this.authenticatedService.getObservable(url);
    }
}

